import { useRouter } from "next/router";
import { createContext, useCallback, useContext } from "react";
import { parseAsBoolean, useQueryState } from "nuqs";
export type EvaluationTab = "runs" | "stats" | "logs" | "review";

interface EvaluationContextInterface {
  tab: EvaluationTab;
  setTab: (tab: EvaluationTab) => void;
  annotatorView: boolean;
  setAnnotatorView: (annotatorView: boolean) => void;
}

const EvaluationContext = createContext<EvaluationContextInterface | undefined>(undefined);

export const useEvaluationContext = () => {
  const context = useContext(EvaluationContext);
  if (context === undefined) {
    throw new Error("useEvaluationContext must be used within a EvaluationContext");
  }
  return context;
};

export const EvaluationContextProvider = ({
  children,
  tab,
}: React.PropsWithChildren<{
  tab: EvaluationTab;
}>) => {
  const router = useRouter();
  const [annotatorView, setAnnotatorView] = useQueryState("focus", parseAsBoolean.withDefault(false));

  const setTab = useCallback(
    (evaluationTab: EvaluationTab) => {
      router.push({ query: { ...router.query, evaluationTab } }, undefined, { shallow: true });
    },
    [router],
  );

  return (
    <EvaluationContext.Provider
      value={{
        tab,
        setTab,
        annotatorView,
        setAnnotatorView,
      }}
    >
      {children}
    </EvaluationContext.Provider>
  );
};
